import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

export function registerFlowSteps(registry: StepRegistry): void {
  registry.register('wait', async (step) => {
    await wait(step.duration);
  });

  registry.register('parallel', async (step, _s, _r, reg) => {
    await Promise.all(step.params.steps.map((s: any) => reg.execute(s)));
  });
}
